import { getDefaultLanguage } from "../actions/ui";
import { LANGUAGE, LOADING, SHOW_GLOBE, SET_LOCATION } from "../constants/ui";

const initialState = {
  loading: false,
  language: getDefaultLanguage(),
  showGlobe: true,
  locations: [],
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    case SHOW_GLOBE:
      return {
        ...state,
        showGlobe: action.payload,
      };
    case SET_LOCATION:
      return {
        ...state,
        locations: action.payload,
      };
    default:
      return state;
  }
};

export default uiReducer;
